// frontend/src/pages/admin/UserFormModal.jsx (نسخه نهایی)

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
import { FaSpinner } from 'react-icons/fa';

const UserFormModal = ({ isOpen, onClose, onUserAdded }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        first_name: '',
        last_name: '',
        role: 'Student',
        organization: '', // اکنون با ID پر می‌شود
    });
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // دریافت لیست سازمان‌ها از API هنگام باز شدن مودال
    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            axios.get(`${API_BASE_URL}/auth/sub-organizations/`, getAuthHeaders())
                .then(response => {
                    setOrganizations(response.data);
                    // انتخاب اولین سازمان به عنوان پیش‌فرض
                    if (response.data.length > 0) {
                        setFormData(prev => ({ ...prev, organization: response.data[0].id }));
                    }
                })
                .catch(err => {
                    setError("خطا در دریافت لیست سازمان‌ها.");
                    console.error(err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${API_BASE_URL}/auth/users/`, formData, getAuthHeaders());
            onUserAdded(response.data);
            onClose();
        } catch (err) {
            const errorData = err.response?.data;
            let errorMessage = "خطا در ایجاد کاربر.";
            if (errorData) {
                // نمایش خطای دقیق‌تر از بک‌اند
                errorMessage = Object.values(errorData).flat().join(' ');
            }
            setError(errorMessage);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>افزودن کاربر جدید</h2>
                    <button onClick={onClose} className="modal-close-btn">&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {error && <div className="alert alert-danger">{error}</div>}
                        
                        {/* ... بقیه فیلدهای فرم ... */}
                        <div className="form-group">
                            <label>نام</label>
                            <input type="text" name="first_name" onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label>نام خانوادگی</label>
                            <input type="text" name="last_name" onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label>نام کاربری (کد ملی)</label>
                            <input type="text" name="username" onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label>رمز عبور</label>
                            <input type="password" name="password" onChange={handleChange} required />
                        </div>
                        
                        {/* فیلد جدید برای انتخاب سازمان */}
                        <div className="form-group">
                            <label>سازمان</label>
                            <select name="organization" value={formData.organization} onChange={handleChange} required>
                                {organizations.map(org => (
                                    <option key={org.id} value={org.id}>
                                        {org.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label>نقش</label>
                            <select name="role" value={formData.role} onChange={handleChange} required>
                                <option value="Student">دانش‌آموز</option>
                                <option value="Teacher">معلم</option>
                                <option value="SchoolAdmin">مدیر مدرسه</option>
                            </select>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button button-secondary" onClick={onClose} disabled={loading}>
                            انصراف
                        </button>
                        <button type="submit" className="button button-primary" disabled={loading}>
                            {loading ? <FaSpinner className="spinner" /> : 'ذخیره کاربر'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserFormModal;